<template>
  <v-card>
    <div
      :class="$vuetify.breakpoint.mobile ? '': 'card-width'"
      class="d-flex flex-column px-5 py-4"
    >
      <div class="d-flex flex-row pb-5 justify-space-between">
        <v-chip
          v-if="offre.isAbonnement"
          color="var(--kaki)"
          label
        >
          <span
            class="action primary--text"
          >
            Abonné
          </span>
        </v-chip>
        <v-chip
          v-else
          color="#FDEEE3"
          label
        >
          <span class="action --text-orange-dark">
            Non abonné
          </span>
        </v-chip>
        <AgrButton
          :disabled="isOpenModalAjoutContenu"
          icon
          @click="onEditOffre()"
        >
          <v-icon color="grey darken-2">
            mdi-pencil-outline
          </v-icon>
        </AgrButton>
      </div>
      <span class="intro --text-grey-dark pb-5">{{ offre.sousTitre }}</span>
      <div class="d-flex justify-center pb-5">
        <v-img
          :src="pathPictogramme"
          class="ma-2"
          max-width="160"
        />
      </div>
      <div class="d-flex flex-row pb-8 justify-space-between">
        <div class="d-flex flex-column">
          <span class="titre-h4 secondary--text pb-2">Prix annuel</span>
          <div class="texte texte-gris-fonce">
            {{ sousTitreTarif }}
          </div>
        </div>
        <div class="d-flex flex-column tarif ml-1">
          <span
            v-if="!offre.isAbonnement"
            class="titre-h1 secondary--text"
          >
            Gratuit
          </span>
          <span
            v-if="offre.tarifTotal"
            class="titre-h4 secondary--text tarif-total"
          >
            {{ offre.tarifTotal }} €
          </span>
          <span
            v-if="offre.tarifAdherent"
            class="chiffre secondary--text"
          >
            {{ offre.tarifAdherent }} €
          </span>
        </div>
      </div>
      <div
        v-if="offre.isAbonnement"
        class="d-flex justify-space-between pb-5"
      >
        <span class="intro --text-grey-dark">Toutes les fonctionnalités non abonnées</span>
        <v-icon class="--text-branche">
          mdi-check
        </v-icon>
      </div>
      <div
        v-if="offre.isAbonnement"
        class="d-flex flex-column align-center"
      >
        <div class="d-flex flex-column align-center separator">
          <v-divider class="divider" />
          <!-- Permet d'effacer le v-divider derrière le bouton -->
          <v-icon
            class="backgroundButton"
            color="white"
            large
          >
            mdi-circle
          </v-icon>
        </div>
        <v-icon
          color="secondary"
          large
        >
          mdi-plus-circle
        </v-icon>
      </div>
      <div
        v-for="(contenu, index) in offre.contenus"
        :key="index"
      >
        <div class="d-flex flex-row justify-space-between py-4">
          <div class="d-flex flex-column justify-center pr-4">
            <span
              :class="offre.isAbonnement ? 'titre-h4 secondary--text' : 'intro texte-gris-fonce'"
              class="mb-2"
            >
              {{ contenu.sousTitre }}
            </span>
            <span
              v-if="offre.isAbonnement"
              class="texte texte-gris-fonce text-justify"
            >
              {{ contenu.description }}
            </span>
          </div>
          <div class="d-flex flex-row align-center">
            <AgrButton
              :disabled="isOpenModalAjoutContenu"
              icon
              @click="onEditContenu(contenu)"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
            <AgrButton
              :disabled="isOpenModalAjoutContenu"
              icon
              @click="onDeleteContenu(contenu)"
            >
              <v-icon color="grey darken-2">
                mdi-trash-can-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>
        <v-divider v-if="index < offre.contenus.length - 1" />
      </div>
      <div class="d-flex flex-column justify-center">
        <v-btn
          class="btn-secondaire mb-3"
          color="branche"
          elevation="0"
          rounded
          @click="onAjoutContenu"
        >
          <v-icon
            class="--text-branche mr-4"
            start
          >
            mdi-plus
          </v-icon>
          <span class="action text- --text-branche">
            Ajouter une ligne
          </span>
        </v-btn>
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalEditOffre"
      fullscreen
      transition="slide-x-transition"
    >
      <EditOffreAbonnementModal
        v-if="isOpenModalEditOffre"
        :offre="offre"
        @close="onCloseEditOffre()"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalAjoutContenu"
      fullscreen
      transition="slide-x-transition"
    >
      <AjoutOffreAbonnementContenuModal
        v-if="isOpenModalAjoutContenu"
        :contenu-abonnement="contenuAbonnementEnModification"
        :offre="offre"
        @close="onCloseAjoutContenu()"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalConfirmDelete"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        @cancel="onCancelDeleteContenu"
        @confirm="onConfirmDeleteContenu"
      >
        <p>Attention, vous souhaitez supprimer le contenu.</p>
        <p>Voulez-vous vraiment continuer ?</p>
      </ConfirmModal>
    </v-dialog>
  </v-card>
</template>

<script>
import {AgrButton} from '@agrial/ui'
import {mapActions} from 'vuex'
import AjoutOffreAbonnementContenuModal
  from '@/views/admin/offre-abonnement/components/modal/ajout-offre-abonnement-contenu-modal.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import EditOffreAbonnementModal from '@/views/admin/offre-abonnement/components/modal/edit-offre-abonnement-modal.vue'

export default {
  name: 'OffreAbonnement',
  components: {EditOffreAbonnementModal, ConfirmModal, AgrButton, AjoutOffreAbonnementContenuModal},
  props: {
    offre: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      loading: {
        suppressionContenu: true
      },
      erreur: {
        suppressionContenu: true
      },
      isOpenModalEditOffre: false,
      isOpenModalAjoutContenu: false,
      isOpenModalConfirmDelete: false,
      contenuAbonnementEnModification: null
    }
  },

  computed: {
    sousTitreTarif () {
      if (this.offre.isAbonnement && this.offre.tarifCoop) {
        return this.offre.tarifCoop + ' € prise en charge par la coopérative'
      } else {
        return 'Sans frais cachés'
      }
    },

    pathPictogramme () {
      if (this.offre.isAbonnement) {
        return '/images/pictogrammes/picto-info-abonnement.svg'
      } else {
        return '/images/pictogrammes/picto-info-abonnement-cadenas.svg'
      }
    }
  },

  methods: {
    ...mapActions({
      deleteOffreAbonnementContenu: 'offreAbonnement/deleteOffreAbonnementContenu'
    }),

    onAjoutContenu () {
      this.isOpenModalAjoutContenu = true
      this.contenuAbonnementEnModification = null
    },

    onEditOffre () {
      this.isOpenModalEditOffre = true
    },

    onEditContenu (contenu) {
      this.isOpenModalAjoutContenu = true
      this.contenuAbonnementEnModification = contenu
    },

    onDeleteContenu (contenu) {
      this.isOpenModalConfirmDelete = true
      this.contenuAbonnementEnModification = contenu
    },

    onCancelDeleteContenu () {
      this.isOpenModalConfirmDelete = false
      this.contenuAbonnementEnModification = null
    },

    onConfirmDeleteContenu () {
      this.loading.suppressionContenu = true
      this.erreur.suppressionContenu = false
      this.isOpenModalConfirmDelete = false

      this.deleteOffreAbonnementContenu(this.contenuAbonnementEnModification.id)
        .catch(() => this.erreur.suppressionContenu)
        .finally(() => {
          this.contenuAbonnementEnModification = null
          this.loading.suppressionContenu = false
        })
    },

    onCloseAjoutContenu () {
      this.isOpenModalAjoutContenu = false
    },

    onCloseEditOffre () {
      this.isOpenModalEditOffre = false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-width {
  width: 400px;
}

.pictogramme {
  width: 160px;
}

.tarif-total {
  text-decoration: line-through;
}

.tarif {
  text-align: end;
  white-space: nowrap;
}

.separator {
  width: 100%;
  position: relative;
}

.divider {
  width: 350px;
  position: absolute;
  top: 17px;
}

.backgroundButton {
  position: absolute;
}
</style>
